import { useId } from 'react';
import {
  DropdownContainer,
  DropdownMenu,
  DropdownOption,
  useDropdownTriggerContainer,
} from '@ardoq/dropdown-2026';
import { Popover2025 } from '@ardoq/popovers';
import { PillButton } from './PillButton';
import { Stack } from '@ardoq/layout';
import { Operator } from '@ardoq/api-types';

export type OperatorOption = {
  value: Operator;
  label: string;
  onClick: VoidFunction;
};

export type OperatorButtonProps = {
  type: 'button';
  button: {
    label: string;
    isPopoverOpen: boolean;
    onClick: VoidFunction;
  };
  popover: {
    isOpen: boolean;
    options: OperatorOption[];
    onClose: VoidFunction;
  };
};

export const OperatorButton = (props: OperatorButtonProps) => {
  const operatorPopoverId = useId();
  const triggerRef = useDropdownTriggerContainer<HTMLButtonElement>({
    isOpen: props.button.isPopoverOpen,
    openDropdown: () =>
      props.button.isPopoverOpen ? null : props.button.onClick(),
  });

  return (
    <>
      <PillButton
        ref={triggerRef}
        $isOperator
        $isActive={props.button.isPopoverOpen}
        onClick={props.button.onClick}
        aria-label={props.button.label}
        aria-haspopup="dialog"
        aria-expanded={props.button.isPopoverOpen}
        aria-controls={operatorPopoverId}
      >
        {props.button.label}
      </PillButton>
      <Popover2025
        id={operatorPopoverId}
        isOpen={props.popover.isOpen}
        onClose={props.popover.onClose}
        onClickOutside={props.popover.onClose}
        anchorRef={triggerRef}
        placement={{
          side: 'bottom',
          overflow: 'right',
        }}
      >
        <DropdownContainer>
          <DropdownMenu>
            <Stack>
              {props.popover.options.map(option => (
                <DropdownOption key={option.value} onClick={option.onClick}>
                  {option.label}
                </DropdownOption>
              ))}
            </Stack>
          </DropdownMenu>
        </DropdownContainer>
      </Popover2025>
    </>
  );
};
